import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { ROLES } from 'config';
import checkAccess from 'utils/roles/checkAccess';
import { getProfileRolesApi } from './api';

const useRoles = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { data } = useQuery(['roles'], getProfileRolesApi, {
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || error.message, { variant: 'error' });
    },

    select: ({ data }) => data,
  });

  const rolesList = data?.filter((item) => ROLES[item]) || [];

  const filteredRoles = () => {
    if (checkAccess([2])) {
      return rolesList.filter(
        (item) => item === 'FRANCHISE_REGION_ADMIN' || item === 'FACILITY_ADMIN' || item === 'VENDOR_ADMIN'
      );
    }

    if (checkAccess([1])) {
      return rolesList.filter((item) => item !== 'SUPER_ADMIN');
    }

    return rolesList;
  };

  return { roles: filteredRoles() };
};

export default useRoles;
